import React from 'react';
import Typography from '@mui/material/Typography';
import Stack from '@mui/material/Stack';

import { clientOptionsKeyFieldsMapping } from './createCounselingCenterStatistics';
import type { CounselingCenterStatistics } from '../../../common/types/statistics/fhbfStatistics';

type Props = {
  statistics: CounselingCenterStatistics;
};

function OptionStatistics({ statistics }: Props) {
  const fieldMapping = clientOptionsKeyFieldsMapping.filter((field) => field.key !== 'onwardPlacement');

  return (
    <Stack direction='column'>
      {fieldMapping.map(({ key, fields }) => {
        const statisticByKey = statistics[key];
        const field = fields.find((field) => field.key === key);
        if (field == null || (field.fieldTypes !== 'select' && field.fieldTypes !== 'checkboxSelect')) {
          return null;
        }
        return (
          <Stack key={key} mb={2}>
            {field.label != null && <Typography fontWeight='bold'>{field.label}</Typography>}
            {Object.keys(statisticByKey).map((statisticKey) => {
              const option = field.options.find((option) => option.value === statisticKey);
              if (statisticKey === 'notSpecified') {
                return <Typography key={statisticKey}>Keine Angabe: {statisticByKey[statisticKey]}</Typography>;
              }

              return option == null ? null : (
                <Typography key={statisticKey}>
                  {option.label}: {statisticByKey[statisticKey]}
                </Typography>
              );
            })}
          </Stack>
        );
      })}
    </Stack>
  );
}

export default OptionStatistics;
